import type { SiteSettings, StartPage as StartPageProps } from '@/@types/content';
import ContentArea from '../cms/ContentArea';
import withNav from '../hocs/withNav';
import { IContent } from '@/@types/cms';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { Helmet } from 'react-helmet';
import { useMemo } from 'react';

const StartPageComponent: React.FC<StartPageProps & SiteSettings> = props => {
  const siteLabels = useSelector((state: RootState) => state.page.siteLabels);

  let walkthroughSteps: Array<IContent> = [];

  if ('walkthroughSteps' in props) {
    walkthroughSteps = props.walkthroughSteps as Array<IContent>;
  }

  const organizationSchema = useMemo(() => {
    const isRelativeImage = siteLabels.organizationLogo?.url?.startsWith('/');
    const logoUrl = isRelativeImage
      ? `${window.location.origin}${siteLabels.organizationLogo?.url}`
      : siteLabels.organizationLogo?.url;

    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteLabels.organizationName,
      url: props.url,
      logo: logoUrl,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: siteLabels.contactPhone,
        contactType: 'Customer Service'
      },
      description: props.pageDescription
    };
  }, [
    siteLabels.organizationName,
    siteLabels.organizationLogo?.url,
    siteLabels.contactPhone,
    props.pageDescription,
    props.url
  ]);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>
      <ContentArea
        components={props.mainContentArea}
        componentsProps={{ walkthroughSteps: walkthroughSteps }}
        propertyName="MainContentArea"
      />
    </>
  );
};

const StartPage = withNav(StartPageComponent);
export default StartPage;
